'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WindIndicator = function WindIndicator(_ref) {
  var direction = _ref.direction,
      speed = _ref.speed,
      units = _ref.units;

  var adjustedSpeed = Math.round(speed);
  return _react2.default.createElement(
    'svg',
    { className: 'quiver-wind-indicator' },
    _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement(
        'g',
        { transform: 'rotate(' + direction + ' 17.5 17.5)' },
        _react2.default.createElement('circle', { cx: '17.5', cy: '17.5', r: '16' }),
        _react2.default.createElement('polygon', { points: '14.5 2.75, 17.5 2.5, 20.5 2.75, 17.5 6' })
      ),
      _react2.default.createElement(
        'g',
        null,
        _react2.default.createElement(
          'text',
          { x: '50%', y: '51%' },
          adjustedSpeed
        ),
        _react2.default.createElement(
          'text',
          { x: '50%', y: '70%' },
          units
        )
      )
    )
  );
};

WindIndicator.propTypes = {
  direction: _propTypes2.default.number,
  speed: _propTypes2.default.number,
  units: _propTypes2.default.string
};

exports.default = WindIndicator;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/WindIndicator/WindIndicator.js
// module id = 698
// module chunks = 11